import React, { useCallback, useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { createPortal } from 'react-dom';
import {
  applicationStore,
  BetResponseCode,
  freeBetStore,
  gameConfigStore,
  isMobile,
  notificationStore,
  NumPad,
  useClickOutside,
  userInfoStore,
  useTranslation,
} from '@pascal/pascal-core';
import { betStore } from '@pascal/pascal-core/shared/core/store';

import { doBetStore } from '../../store/doBetStore';
import { gameStore } from '../../store/gameStore';
import { BetSections } from '../betSections';
import { gameService } from '../../services';

let mobileWrRef;

const NumPadWrapper = ({ containerRef, children }) => {
  if (containerRef) {
    return createPortal(children, containerRef);
  }
  return null;
};

export const GameContentInner = observer(() => {
  const { reportResult, currentRound, wageringOdd, numPadData, gameScene } = gameStore;
  const { activeFreeBet } = freeBetStore;
  const { isDemo } = applicationStore;
  const { userBets } = doBetStore;
  const t = useTranslation();

  const { limits, gameId } = gameConfigStore;
  const { precision, currencyCode, currencySymbolOrCode } = userInfoStore;
  const { freeBets } = freeBetStore;
  const [amountValue, setAmountValue] = useState();
  const { repliedBetData } = betStore;
  const [betSections, setBetSections] = useState([
    {
      index: 0,
      betAmount: '',
      isOpen: true,
    },
    {
      index: 1,
      betAmount: '',
      isOpen: true,
    },
  ]);

  const [ref, hasClickedOutside] = useClickOutside();

  useEffect(() => {
    if (hasClickedOutside) {
      gameStore.setNumPudData({
        isOpen: false,
        sectionIndex: null,
      });
    }
  }, [hasClickedOutside]);

  const handleBetSectionsAmount = (value) => {
    return betSections.map((section) => ({
      ...section,
      betAmount: value,
    }));
  };

  useEffect(() => {
    const handleStateSections = handleBetSectionsAmount(
      limits?.defaultBetAmount || limits?.minBet || repliedBetData?.amount
    );
    setBetSections(handleStateSections);
    setAmountValue(limits?.defaultBetAmount || limits?.minBet);
    // if (betSections?.every((item) => item.betAmount)) {
    //   iframeService.sendStakeUpdate(multiply(2, limits.defaultBetAmount || limits?.minBet));
    // }
  }, [limits, repliedBetData]);

  const handleBetSectionsState = (changeBet, index) => {
    const changedBetSections = betSections.map((section) =>
      section.index === index
        ? {
            ...section,
            betAmount: changeBet,
          }
        : section
    );
    // if (isNumPad) {
    // iframeService.sendStakeUpdate(
    //   changedBetSections.reduce((acc, curr) => acc + curr?.betAmount, 0)
    // );
    // }
    setBetSections(changedBetSections);
  };

  useEffect(() => {
    mobileWrRef = document.querySelector('.pgc-m-game-holder');
  }, []);

  const handleSubmit = (isConfirmed = false) => {
    const { sectionIndex: index } = numPadData;
    const { minBet, maxBet } = limits;
    if (isConfirmed) {
      if (amountValue && +amountValue >= minBet && +amountValue <= maxBet) {
        handleBetSectionsState(amountValue, index);
      } else if (amountValue && amountValue > maxBet) {
        notificationStore.setNotificationType(BetResponseCode.InValidMaxBetWithValue);
        handleBetSectionsState(maxBet, index);
      } else if (!amountValue || +amountValue < minBet) {
        notificationStore.setNotificationType(BetResponseCode.InValidMinBetWithValue);
        handleBetSectionsState(minBet, index);
      }
      gameStore.setNumPudData({ isOpen: false, sectionIndex: null });
    }
  };

  const handleInputClick = (index, isOnClick) => {
    if (isMobile()) {
      document.activeElement.blur();
      if (isOnClick) {
        gameStore.setNumPudData({ isOpen: true, sectionIndex: index });
        handleBetSectionsState(betSections[index].betAmount, index);
        setAmountValue(betSections[index].betAmount);
      }
    }
  };

  // const handleChangeInputValue = (index, action, number = null) => {
  //   getValidatedBetAmount(
  //     index,
  //     action,
  //     number,
  //     betSections[index]?.betAmount,
  //     limits,
  //     isDemo,
  //     balance,
  //     handleBetSectionsState
  //   );
  // };

  const handleIsShowSection = useCallback(
    (index) => {
      const existClosedBetSections = betSections.some((section) => !section.isOpen);
      const updateBetSection = betSections.map((section) => {
        if (existClosedBetSections) {
          return {
            ...section,
            isOpen: existClosedBetSections,
          };
        }
        if (section.index === index) {
          return {
            ...section,
            isOpen: !section.isOpen,
            betAmount: limits?.minBet,
          };
        }
        return section;
      });
      setBetSections(updateBetSection);
    },
    [betSections]
  );

  const plusOrCloseIcon = betSections.some((section) => !section.isOpen);

  const doBet = (index) => {
    const { betAmount } = betSections[index];
    const { id: freeBetId, amount, minOdd: freeBetMinOdd } = activeFreeBet;
    const doBetModel = {
      amount: freeBetId ? amount : +betAmount,
      roundId: currentRound.roundId,
      ...(freeBetId ? { freeBetId, amount, freeBetMinOdd } : {}),
      betData: { index, ...(freeBetId ? { freeBetMinOdd } : {}) },
    };
    doBetStore?.setTotalBetAmount(betSections?.reduce((acc, curr) => +acc + +curr?.betAmount, 0));
    gameService.sendBet(doBetModel);
  };

  const cashOut = (index) => {
    doBetStore.cashOut({
      roundId: currentRound.roundId,
      betId: userBets[index]?.id,
      sectionId: index,
    });
  };

  return (
    <>
      <BetSections
        t={t}
        gameId={gameId}
        isDemo={isDemo}
        doBet={doBet}
        limits={limits}
        userBets={userBets}
        cashOut={cashOut}
        demoMode={isDemo}
        gameScene={gameScene}
        precision={precision}
        wageringOdd={wageringOdd}
        reportList={reportResult}
        activeFreeBet={activeFreeBet}
        currencyCode={currencyCode}
        freeBetsList={freeBets}
        currencySymbolOrCode={currencySymbolOrCode}
        // handleChangeInputValue={handleChangeInputValue}
        disabledBetButton={doBetStore.disabledBetButton}
        disabledCashOutButton={doBetStore.disabledCashOutButton}
        betSections={betSections}
        handleBetSectionsState={handleBetSectionsState}
        handleIsShowSection={handleIsShowSection}
        plusOrCloseIcon={plusOrCloseIcon}
        handleInputClick={handleInputClick}
        currentRoundData={currentRound}
      />
      {/*<BetSections />*/}
      {numPadData.isOpen && !activeFreeBet.id && (
        <NumPadWrapper containerRef={mobileWrRef}>
          <div ref={ref} className='numpad-wr-for-outside-click'>
            <NumPad
              t={t}
              limits={limits}
              isOpen={numPadData.isOpen}
              precision={precision}
              onSubmit={handleSubmit}
              amountValue={amountValue}
              setAmountValue={setAmountValue}
            />
          </div>
        </NumPadWrapper>
      )}
    </>
  );
});
